<template>
  <div>
  <div class="index">
    <div class="content">
      <div class="sTitle">电子保函验真平台</div>
      <div class="content-right">
        <!-- <div class="right-tit">
          {{ isOpen == 1 ? "填写以下信息即可查询验证您的保函" : "核验成功" }}
        </div> -->
        <!-- <div class="title">
          <Title
            :title="
              isOpen == 1 ? '填写以下信息即可查询验证您的保函' : '核验成功'
            "
          >
          </Title>
        </div> -->
        <div class="right-con" v-if="isOpen == 1">
          <a-form-model
            ref="form1"
            :model="applicantInform"
            :rules="rule1"
            :label-col="{ xs: { span: 12 }, sm: { span: 4 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 12 } }"
          >
            <a-form-model-item label="保函编号" prop="guaranteeNo">
              <a-input v-model="applicantInform.guaranteeNo" />
            </a-form-model-item>
            <a-form-model-item label="企业名称" prop="customerName">
              <a-input v-model="applicantInform.customerName" />
            </a-form-model-item>
            <a-form-model-item label="验证码" class="code_img" prop="code">
              <!-- <div style="display:flex;"> -->
              <a-input style="width:160px" v-model="applicantInform.code" />
              <img
                :src="codeImg"
                class="img_code"
                alt=""
                style="height: 35px;margin-left: 13px;"
                @click="getImgcode"
              />
              <!-- </div> -->
            </a-form-model-item>
          </a-form-model>
          <div class='btns' style="display:flex;">
            <a-button class="btn_le" @click="handleReset">
              重置
            </a-button>
            <a-button type="primary" class="btn" @click="handleSubmit">
              提交
            </a-button>
          </div>
        </div>
        <div class="right-cons" v-if="isOpen == 2">
          <img src="../../assets/image/heyan.png" alt="" width="100px"/>
          <div class="con-text">
            核验成功
          </div>
          <div style="background: #fafafa;position: relative;">
            <a-form-model
              ref="form1"
              :model="form"
              :rules="rule1"
              :label-col="{ xs: { span: 12 }, sm: { span: 6 } }"
              :wrapper-col="{ xs: { span: 24 }, sm: { span: 12 } }"
            >
              <a-form-model-item label="保函编号">
                <div>{{ form.guaranteeNo }}</div>
              </a-form-model-item>
              <a-form-model-item label="被保证人">
                <div>{{ form.businessOrgName }}</div>
              </a-form-model-item>
              <a-form-model-item label="保函金额">
                <div>{{ form.amount }}元</div>
              </a-form-model-item>
              <a-form-model-item label="保函有效期">
                <div>{{ form.bidDate }}</div>
              </a-form-model-item>
            </a-form-model>
            <div class="bg-box" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <Footer></Footer> -->
  </div>
</template>
<script>
import { graphicsCode, smsCode } from '@/api/code.js';
import { check } from '@/api/guaranteeTruth.js';
import Footer from "@/views/index/footer.vue";
export default {
  components: { Footer },
  data() {
    // const compareToFirstPhone = (rule, value, callback) => {
    //   const pattern = /^1[3|4|5|7|8|9][0-9]{9}$/;
    //   if (pattern.test(value)) {
    //     callback();
    //   } else if (!value) {
    //     callback('请输入手机号');
    //   } else {
    //     callback('手机号格式不正确');
    //   }
    // };
    return {
      isOpen: 1,
      codeImg: '',
      isTime: true,
      applicantInform: {
        customerName: '',
        guaranteeNo: '',
        code: '',
      },
      form: {
        guaranteeNo: '',
        businessOrgName: '',
        amount: '',
        guaranteeStatusDescribe: '',
        guaranteeStatus: '',
      },
      rule1: {
        guaranteeNo: [{ required: true, message: '请输入保函编号', trigger: 'blur' }],
        customerName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
    };
  },
  mounted() {
    this.getImgcode();
  },
  methods: {
    getImgcode() {
      graphicsCode({ source: 'ACC_USER_LOGIN' }).then(res => {
        this.codeImg = window.URL.createObjectURL(res.data);
      });
    },
    getCode() {
      this.timer = '';
      if (this.applicantInform.code !== '' && this.applicantInform.responsiblePersonPhone !== '' && !!this.applicantInform.code) {
        smsCode({ source: 'ACC_USER_LOGIN', checkCode: this.applicantInform.code, phoneNum: this.applicantInform.responsiblePersonPhone }).then(res => {
          this.isCode = res.data;
          if (res.data.status === 'FAIL') {
            this.$message.warning(this.isCode.errorMsg);
          } else {
            this.isTime = false;
            this.timer = setInterval(this.countDown, 1000);
          }
        });
      } else {
        this.$message.warning('手机号码和图形验证码不为空');
      }
    },
    countDown() {
      if (this.time > 0) {
        this.time--;
      } else {
        this.time = 10;
        this.isTime = true;
        clearInterval(this.timer);
      }
    },
    handleReset() {
      this.$refs.form1.resetFields();
    },
    handleSubmit() {
      this.$refs.form1.validate(valid => {
        if (valid) {
          check({ ...this.applicantInform }).then(res => {
            if (res.data.status === 500) {
              this.$notification.error({ message: res.data.message });
            } else {
              this.form = res.data.data;
              this.isOpen = 2;
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  display: flex;
  flex-direction: column;
  background-color: #f2f2f2;
  background: url("../../assets/info/bhyz.png") no-repeat;
  height: 705px;
}
.content {
  .sTitle {
    font-weight: 500;
    font-size: 32px;
    color: #333333;
    text-align: center;
    padding-top: 90px;
  }
}
.content-right {
  .right-tit {
    padding: 30px 0 15px;
    height: 70px;
    font-weight: 400;
    font-size: 14px;
    border-bottom: 1px solid #ececec;
  }
  .right-tips {
    color: cornflowerblue;
    margin: 20px 0;
  }
  .right-con {
    background: #fff;
    box-shadow: 0px 8px 27px 0px rgba(0,0,0,0.04);
    border-radius: 10px;  
    width: 510px;
    height: 358px;
    margin: 39px auto 0;
    padding: 40px 0px;
    padding-left: 88px;
    
  }
  .right-cons {
    background: #fff;
    box-shadow: 0px 8px 27px 0px rgba(0,0,0,0.04);
    border-radius: 10px;
    width: 510px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 39px auto 0;
    padding: 40px 0px;
    .con-text {
      font-size: 20px;
      margin: 20px 0;
    }
  }
}
.nextBtn {
  margin-top: 30px;
  ::v-deep .ant-form-item-control {
    left: 45%;
  }
  ::v-deep .ant-btn:nth-of-type(1) {
    margin-left: 0px !important;
  }
  ::v-deep .ant-btn {
    width: 120px;
    height: 40px;
    margin-left: 30px;
  }
}
.bg-box {
  position: absolute;
  left: 0;
  top: 0;
  width: 120px;
  height: 256px;
  background: #f2f2f2 !important;
}
::v-deep .ant-form {
  display: flex;
  flex-direction: column;
  align-items: center;
}
::v-deep .ant-form-item {
  width: 500px;
  z-index: 10;
}
::v-deep .ant-form-item-label {
  white-space: normal;
}
::v-deep .ant-steps-item-container {
  height: 120px;
}
::v-deep .ant-input,
.ant-select,
.ant-select-selection {
  width: 300px;
}
.code_img {
  .img_code {
    width: 125px;
    height: 29px;
    position: absolute;
  }
}
.btns {
  margin-left: 45px;
}
.title {
  margin-bottom: 100px;
}
.btn_le {
  width: 144px;
  height: 37px;
  border-radius: 6px;
  opacity: 1;
  border: 1px solid #d6d6d6;
  font-size: 14px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  margin-right: 8px;
  color: #999;
}
.btn {
  width: 144px;
  height: 37px;
  border-radius:6px;
  border: 1px solid #0E52D4 !important;
  background: #0E52D4;
  color: #fff;
}
.nav_box {
  width: 100%;
  height: 210px;
  background: url("../../assets/info/nav_banner.png") no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  .text {
    position: absolute;
    width: 100%;
    text-align: center;
    left: 0;
    top: 61px;
    font-size: 36px;
    font-family: Source Han Sans CN-Light, Source Han Sans CN;
    font-weight: 300;
    color: #ffffff;
  }
}
</style>
